import {Component, OnInit} from "@angular/core";
import {AbstractComponent} from "../../abstract-component/abstract.component";
import {UrlTree, Router} from "@angular/router";
import { environment } from "../../../environments/environment";

@Component({
    selector: 'app-end-of-study',
    templateUrl: './end-of-study.component.html',
    styleUrls: ['./end-of-study.component.scss']
})
export class EndOfStudyComponent extends AbstractComponent {

    grandCompte: string;
    externalAccountUrl: string;

    constructor(private router: Router) {
        super();
    }

    ngOnInit() {
        super.ngOnInit();
        this.grandCompte = environment.grandCompte;
        this.externalAccountUrl = environment.external_account_url;
    }

    protected modifyConfiguration(): void {

        this.confDataService.updateElementValues("contact-form-valid", undefined);
        this.confDataService.updateElementOptions("contact-form-valid", undefined);

        const urlTree: UrlTree = this.router.parseUrl(this.router.url);
        const lang = urlTree.root.children.primary.segments[1].path;
        const commands: string[] = ["/lang", lang, "project-type-choice", "project-type"];
        this.router.navigate(commands);

    }
}



// WEBPACK FOOTER //
// ./src/app/main-view/end-of-study/end-of-study.component.ts